module.exports = __webpack_public_path__ + "img/Conversations_W.aaa5877c.png";